module.exports = __webpack_public_path__ + "media/images/flags/cy-f9c9bf9a80cc6d96dccba0504a849e81.svg";